import { Icon, IconProps } from '@chakra-ui/react';

export function FileUploadedIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill={'currentcolor'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)">
        <path d="M19.044 10.596H9.427a1.611 1.611 0 1 0 0 3.222h9.617a1.612 1.612 0 0 0 0-3.222ZM19.044 17.041H9.427a1.611 1.611 0 1 0 0 3.223h9.617a1.612 1.612 0 0 0 0-3.223ZM19.044 23.487H9.427a1.611 1.611 0 1 0 0 3.223h9.617a1.611 1.611 0 0 0 0-3.223ZM19.044 29.933H9.427a1.611 1.611 0 1 0 0 3.223h9.617a1.611 1.611 0 0 0 0-3.223ZM19.044 36.486H9.427a1.611 1.611 0 0 0 0 3.223h9.617a1.611 1.611 0 0 0 0-3.223ZM24.455 13.818h9.617a1.611 1.611 0 1 0 0-3.222h-9.617a1.611 1.611 0 0 0 0 3.222ZM24.455 20.264h9.617a1.611 1.611 0 1 0 0-3.223h-9.617a1.611 1.611 0 0 0 0 3.223ZM30.698 25.099c0-.89-.721-1.612-1.611-1.612h-4.632a1.611 1.611 0 0 0 0 3.223h4.632c.89 0 1.611-.722 1.611-1.611ZM45.963 37.167a1.611 1.611 0 0 0-2.265.248l-4.15 5.174-2.57-1.861a1.611 1.611 0 1 0-1.89 2.61l3.81 2.76a1.606 1.606 0 0 0 2.203-.296l5.11-6.37a1.611 1.611 0 0 0-.248-2.265Z" />
        <path d="M50.035 32.22a13.288 13.288 0 0 0-7.717-3.878V6.489A6.497 6.497 0 0 0 35.828 0H7.671a6.497 6.497 0 0 0-6.49 6.49v37.325a6.497 6.497 0 0 0 6.49 6.49h22.646A13.264 13.264 0 0 0 40.494 55c7.379 0 13.382-6.007 13.382-13.391 0-3.535-1.364-6.87-3.84-9.389ZM4.405 43.816V6.489A3.27 3.27 0 0 1 7.67 3.223h28.157a3.27 3.27 0 0 1 3.267 3.266v21.802c-6.724.702-11.983 6.406-11.983 13.318 0 1.915.4 3.767 1.166 5.473H7.67a3.27 3.27 0 0 1-3.267-3.267Zm36.089 7.961a10.083 10.083 0 0 1-8.117-4.053 10.086 10.086 0 0 1-2.043-6.115c0-5.607 4.558-10.169 10.16-10.169l.159.002h.025a10.095 10.095 0 0 1 7.06 3.037 10.113 10.113 0 0 1 2.915 7.13c0 5.607-4.557 10.168-10.16 10.168Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h55v55H0z" />
        </clipPath>
      </defs>
    </Icon>
  );
}
